var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_96906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8132 30L15 28.22L23.3837 19.99L15 11.78L16.8132 10L27 20L16.8132 30Z",
    fill: "#333233"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_96906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 20,
    fill: "white",
    transform: "translate(15 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevron);
export default __webpack_public_path__ + "static/media/Ic_chevron.48fe6ce831c73aa7d344cbc3c5bacba5.svg";
export { ForwardRef as ReactComponent };